import React, { useRef, useState, useEffect } from "react";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const SettingsComponent = ({handleShowReceiveStat}) => {
  const [senderStat, setsenderStat] = useState(false);
  const [receiverStat, setreceiverStat] = useState(false);
  const [binStat, setbinStat] = useState(false);
  return (
    <>
      <div style={{textAlign:"center"}}>
        <Button
          variant={!binStat ? "secondary" : "primary"}
          style={{ display: "block", margin: 2 + "px" }}
          onClick={() => {
            setbinStat(true);
            fetch("http://127.0.0.1:8080/selectBin");
          }}
        >
          Set Your CMIX Folder Location First
        </Button>
      </div>
      <div style={{ textAlign: "center" }}>
        <Button
          variant={!senderStat ? "secondary" : "primary"}
          style={{ display: "inline-block", margin: 2 + "px" }}
          onClick={() => {
            setsenderStat(!senderStat);
          }}
        >
          Sender
        </Button>
        <Button
          variant={!receiverStat ? "secondary" : "primary"}
          style={{ display: "inline-block", margin: 2 + "px" }}
          onClick={() => {
            setreceiverStat(true);
            handleShowReceiveStat();
            setTimeout(()=>{
              fetch("http://127.0.0.1:8080/runCommandsForPorts").then(()=>{
                
              });
            }, 50);
            
          }}
        >
          Receiver
        </Button>
      </div>

      {senderStat ? (
        <>
          <InputGroup size="sm" style={{ padding: "2px" }}>
            <InputGroup.Text>Player Number</InputGroup.Text>
            <Form.Control id="playerNum" />
          </InputGroup>
          <InputGroup size="sm" style={{ padding: "2px" }}>
            <InputGroup.Text>IP address</InputGroup.Text>
            <Form.Control id="ip" />
          </InputGroup>
        </>
      ) : null}
    </>
  );
};

export default SettingsComponent;
